
export default class cookieOps {

    static writeCookie(list){
        Object.keys(list).map((key) => {
            localStorage.setItem(key, list[key]);
        })
    }

    static readCookie(key){
        const item = localStorage.getItem(key);
        return item || '';
    }

    static clearCookie(key){
        localStorage.removeItem(key);
    }
}